import React, { useEffect, useState } from 'react';
import './App.css';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { BsCheckLg } from 'react-icons/bs';
import { MdDarkMode, MdLightMode } from 'react-icons/md';

function App() {
  const [isCompleteScreen, setIsCompleteScreen] = useState(false);
  const [allTodos, setTodos] = useState([]);
  const [newTitle, setNewTitle] = useState("");
  const [newDescription, setNewDescription] = useState("");
  const [completedTodo, setCompletedTodos] = useState([]);
  const [currentEdit, setCurentEdit] = useState("");
  const [currentEditedItem, setCurrentEditedItem] = useState("");
  const [darkTheme, setDarkTheme] = useState(false);

  const handleAddTodo = () => {
    let newTodoItem = {
      title: newTitle,
      description: newDescription
    };
    let updateTodoArr = [...allTodos];
    updateTodoArr.push(newTodoItem);
    setTodos(updateTodoArr);
    localStorage.setItem("todolist", JSON.stringify(updateTodoArr));
  };

  const handleDeleteTodo = index => {
    let reducedTodo = [...allTodos];
    reducedTodo.splice(index, 1);
    localStorage.setItem("todolist", JSON.stringify(reducedTodo));
    setTodos(reducedTodo);
  };



  const handleComplete = index => {
    let now = new Date();
    let dd = now.getDate();
    let mm = now.getMonth() + 1;
    let yyyy = now.getFullYear();
    let hh = now.getHours();
    let m = now.getMinutes();
    let s = now.getSeconds();
    let completedOn = `${dd}/${mm}/${yyyy} ${hh}:${m}:${s}`;
    let filteredItem = {
      ...allTodos[index],
      completedOn: completedOn
    };
    let updatedCompletedArr = [...completedTodo];
    updatedCompletedArr.push(filteredItem);
    setCompletedTodos(updatedCompletedArr);
    handleDeleteTodo(index);
    localStorage.setItem("completedTodo", JSON.stringify(updatedCompletedArr));
  };
  const handleDeleteCompletedTodo = index => {
    let reducedCompletedTodo = [...completedTodo];
    reducedCompletedTodo.splice(index, 1);
    localStorage.setItem("completedTodo", JSON.stringify(reducedCompletedTodo));
    setCompletedTodos(reducedCompletedTodo);
  };
  const handleUpdateToDo = () => {
    let newTodo = [...allTodos];
    newTodo[currentEdit] = currentEditedItem;
    setTodos(newTodo);
    setCurentEdit("");
    localStorage.setItem("todolist", JSON.stringify(newTodo));
  }
  useEffect(() => {
    let savedTodo = JSON.parse(localStorage.getItem("todolist"));
    if (savedTodo) {
      setTodos(savedTodo);
    }
    let savedCompletedTodo = JSON.parse(localStorage.getItem("completedTodo"));
    if (savedCompletedTodo) {
      setCompletedTodos(savedCompletedTodo);
    }
  }, []);
  useEffect(() => {
    if (darkTheme) {
      document.body.classList.add('dark');
      document.body.classList.remove('light');
    } else {
      document.body.classList.add('light');
      document.body.classList.remove('dark');
    }
  }, [darkTheme]);
  const handleEdit = (ind, item) => {
    setCurentEdit(ind);
    setCurrentEditedItem(item);
  }
  const handleUpdateTitle = (value) => {
    setCurrentEditedItem((prev) => {
      return { ...prev, title: value }
    })
  }
  const handleUpdateDescription = (value) => {
    setCurrentEditedItem((prev) => {
      return { ...prev, description: value }
    })
  }
  return (
    <div className="App">
      <h1>My <span>Todos</span></h1>
      <div className='top-bar'>
  <button
    className='theme-toggle-btn'
    onClick={() => setDarkTheme(!darkTheme)}
    title={darkTheme ? 'Switch to Light Theme' : 'Switch to Dark Theme'}
  >
    {darkTheme ? < MdDarkMode/> : < MdLightMode/>}
  </button>
</div>
      <div className='todo-wrapper'>
        <div className='todo-input'>
          <div className='todo-input-item'>
            <label>Title</label>
            <input type="text" value={newTitle} onChange={(e) => setNewTitle(e.target.value)} placeholder='Enter a new todo' />
          </div>
          <div className='todo-input-item'>
            <label>Description</label>
            <input type="text" value={newDescription} onChange={(e) => setNewDescription(e.target.value)} placeholder='Enter a description' />
          </div>
          <div className='todo-input-item'>
            <button type='button' onClick={handleAddTodo} className='primaryBtn'>Add</button>
          </div>
        </div>
        <div className='btn-area'>
          <button
            className={`secondaryBtn ${!isCompleteScreen ? 'active' : ''}`}
            onClick={() => setIsCompleteScreen(false)}
          >
            Todo
          </button>

          <button
            className={`secondaryBtn ${isCompleteScreen ? 'active' : ''}`}
            onClick={() => setIsCompleteScreen(true)}
          >
            Completed
          </button>
        </div>
        <div className='todo-list'>
          {isCompleteScreen === false &&
            allTodos.map((item, index) => {
              if (currentEdit === index) {
                return (
                  <div className='edit_Wrapper' key={index}>
                    <input placeholder='Updated Title'
                      value={currentEditedItem.title}
                      onChange={(e) => handleUpdateTitle(e.target.value)} />
                    <textarea placeholder='Updated Description'
                      value={currentEditedItem.description}
                      onChange={(e) => handleUpdateDescription(e.target.value)}
                      rows={4} />
                    <button type='button'
                      onClick={handleUpdateToDo}
                      className='primaryBtn'>Update</button>

                  </div>)
              } else {
                return (
                  <div className='todo-list-item' key={index}>
                    <div>
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                    <div>
                      <AiOutlineDelete className='icon' onClick={() => handleDeleteTodo(index)} title='delete?' />
                      <BsCheckLg className='check-icon' onClick={() => handleComplete(index)} title='mark as complete' />
                      <AiOutlineEdit className='check-icon' onClick={() => handleEdit(index, item)} title='edit?' />
                    </div>
                  </div>
                );
              }
            })}
          {isCompleteScreen === true && completedTodo.map((item, index) => (
            <div className='todo-list-item' key={index}>
              <div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <p>
                  <small>Completed on: {item.completedOn}</small>
                </p>
              </div>
              <div>
                <AiOutlineDelete className='icon' onClick={() => handleDeleteCompletedTodo(index)} title='delete?' />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;
